<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      :includeAdmin="true"
    ></results-bar>
    <results-user
      v-if="!summary"
      :uid="currentUser"
      :id="doc.id"
      :key="currentUser"
    ></results-user>
  </div>
</template>

<script>
import { ResultsUser, ResultsBar } from "@/components/results/service";
export default {
  name: "ResultSwot",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
  },
};
</script>
